import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import TransactionSaleForm from "./transactionSaleForm";
import TransactionPurchaseForm from "./transactionPurchaseForm";
import TransactionExpenseForm from "./transactionExpenseForm";
import Tab from "../Tab";

const Transaction = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedAmountType, setSelectedAmountType] = useState("Sale");

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    setSelectedAmountType(
      currentPath.charAt(0).toUpperCase() + currentPath.slice(1)
    );
  }, [location]);

  const handleAmountType = (amountType) => {
    setSelectedAmountType(amountType);
    navigate(`/home/transaction/${amountType.toLowerCase()}`);
  };

  const tabs = [
    { title: "Sale", key: "Sale" },
    { title: "Purchase", key: "Purchase" },
    { title: "Expense", key: "Expense" },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mt-8 max-lg:flex-col max-lg:gap-5">
        <Tab
          tabs={tabs}
          selectedAmountType={selectedAmountType}
          handleAmountType={handleAmountType}
        />
      </div>

      <div className="my-8 bg-white p-[30px] rounded-2xl">
        <Routes>
          <Route path="sale" element={<TransactionSaleForm />} />
          <Route path="purchase" element={<TransactionPurchaseForm />} />
          <Route path="expense" element={<TransactionExpenseForm />} />
        </Routes>
      </div>
    </div>
  );
};

export default Transaction;
